import { useEffect } from 'react';

/**
 * Custom hook to set page title according to WCAG 2.2 guidelines
 * @param {string} pageTitle - The specific page title
 */
const usePageTitle = (pageTitle) => {
  useEffect(() => {
    const appName = 'Carson Quality Control';
    document.title = pageTitle ? `${pageTitle} - ${appName}` : appName;

    // Focus the page heading after navigation for screen reader announcement
    const timer = setTimeout(() => {
      const heading = document.querySelector('#main-content h1');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: false });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [pageTitle]);
};

export default usePageTitle;
